import { Pipe, PipeTransform } from '@angular/core';
import { Investor } from '@core/models/auxiliary-company-models';
import { Nullable } from '@models/nullable';

@Pipe({
  name: 'investorsDetails'
})
export class InvestorsDetailsPipe implements PipeTransform {

  transform(value: Investor[]): any {
    const investors = value;
    const investorsList = investors && investors.length > 0 
      ? investors.map((item: Investor) => item.name).join("\n") 
      : "-";

      return investorsList;
  }
}
